/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillDetailAdditionalServiceCreateReqVo
 */
export interface BillDetailAdditionalServiceCreateReqVo {
    /**
     * 账单ID
     * @type {number}
     * @memberof BillDetailAdditionalServiceCreateReqVo
     */
    billId: number;
    /**
     * 附加服务ID
     * @type {number}
     * @memberof BillDetailAdditionalServiceCreateReqVo
     */
    additionalServiceId: number;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof BillDetailAdditionalServiceCreateReqVo
     */
    amount: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillDetailAdditionalServiceCreateReqVo
     */
    currencyCode?: string;
}

/**
 * Check if a given object implements the BillDetailAdditionalServiceCreateReqVo interface.
 */
export function instanceOfBillDetailAdditionalServiceCreateReqVo(value: object): value is BillDetailAdditionalServiceCreateReqVo {
    if (!('billId' in value) || value['billId'] === undefined) return false;
    if (!('additionalServiceId' in value) || value['additionalServiceId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function BillDetailAdditionalServiceCreateReqVoFromJSON(json: any): BillDetailAdditionalServiceCreateReqVo {
    return BillDetailAdditionalServiceCreateReqVoFromJSONTyped(json, false);
}

export function BillDetailAdditionalServiceCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailAdditionalServiceCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'],
        'additionalServiceId': json['additionalServiceId'],
        'amount': json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
    };
}

export function BillDetailAdditionalServiceCreateReqVoToJSON(json: any): BillDetailAdditionalServiceCreateReqVo {
    return BillDetailAdditionalServiceCreateReqVoToJSONTyped(json, false);
}

export function BillDetailAdditionalServiceCreateReqVoToJSONTyped(value?: BillDetailAdditionalServiceCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'additionalServiceId': value['additionalServiceId'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
    };
}

